import { render, staticRenderFns } from "./auditDiscount.vue?vue&type=template&id=f9a6b700&scoped=true"
import script from "./auditDiscount.vue?vue&type=script&lang=js"
export * from "./auditDiscount.vue?vue&type=script&lang=js"
import style0 from "./auditDiscount.vue?vue&type=style&index=0&id=f9a6b700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a6b700",
  null
  
)

export default component.exports